export default "__VITE_ASSET__2e5b872c__"